var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwalletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000042714044201461572500000008609596902325240765_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.51,
    d: "M44.1767 16.2307H28.9596C28.215 16.2307 27.5977 15.6261 27.5977 14.8688V8.35806C27.5977 7.61343 28.2023 6.99609 28.9596 6.99609H44.8577C45.2395 6.99609 45.5387 7.29522 45.5387 7.67708V14.8815C45.5259 15.6261 44.9213 16.2307 44.1767 16.2307Z",
    fill: "#AD83FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M40.3703 13.0818H26.3052C25.8851 13.0818 25.5605 12.7381 25.5605 12.3372V4.59814C25.5605 4.1781 25.9042 3.85352 26.3052 3.85352H40.383C40.8031 3.85352 41.1277 4.19719 41.1277 4.59814V12.3372C41.134 12.7572 40.7904 13.0818 40.3703 13.0818Z",
    fill: "#AD83FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.9,
    d: "M49.6437 19.765H33.141C32.7465 19.765 32.4219 19.4531 32.4219 19.0458V11.0395C32.4219 10.6449 32.7337 10.3203 33.141 10.3203H49.6437C50.0383 10.3203 50.3629 10.6322 50.3629 11.0395V19.0394C50.3693 19.434 50.0383 19.765 49.6437 19.765Z",
    fill: "#AD83FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.2342 37.9917C39.8811 44.1079 32.7339 48.0983 24.6576 48.0983C11.3944 48.0983 0.638672 37.3426 0.638672 24.0793C0.638672 11.3953 10.4779 1.00233 22.9392 0.124057C23.0411 0.124057 23.1365 0.111328 23.2384 0.111328C24.0275 0.136785 24.6576 0.728667 24.6576 1.46056V10.1224C16.9377 10.1224 10.6879 16.3785 10.6879 24.0921C10.6879 31.8056 16.9441 38.0618 24.6576 38.0618C32.3712 38.0618 38.6273 31.8056 38.6273 24.0921C38.6273 24.0921 46.4363 27.3188 44.2342 37.9917Z",
    fill: "#925AFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M48.6123 25.9307C48.4914 24.8933 47.5622 24.0914 46.423 24.0914H26.2799C25.3889 24.0914 24.6634 23.3723 24.6634 22.4749V1.4599C24.6634 0.728008 24.0333 0.136126 23.2441 0.110669C23.3332 0.110669 23.4287 0.0979394 23.5178 0.0979394C24.5425 0.0852107 25.0898 0.505256 25.2362 0.638906L25.2489 0.651636L25.2744 0.677093L46.9067 22.3094C48.7396 24.1551 48.6123 25.9307 48.6123 25.9307Z",
    fill: "#AD83FF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000125596226527651684890000005932628008421848748_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.91,
    d: "M48.5998 25.912C48.5871 26.1793 48.5616 26.4402 48.5362 26.6884C48.0843 30.8698 46.5569 34.7329 44.2339 37.9915C46.436 27.3121 38.627 24.0918 38.627 24.0918H46.4169C47.5625 24.0918 48.4916 24.8937 48.5998 25.912Z",
    fill: "url(#paint0_linear_1473_18354)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1473_18354",
    x1: 43.6134,
    y1: 38.5397,
    x2: 43.6134,
    y2: 24.1525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.52446e-8,
    stopColor: "#925AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#713BBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwalletIcon);
export default __webpack_public_path__ + "static/media/owallet-icon.3098943b372c5995420049e6f3701921.svg";
export { ForwardRef as ReactComponent };